import * as AppRoutesUrl from 'src/utils/constants/app-routes';
import * as AppRoutesName from 'src/utils/constants/app-routes-name';
import ApplicationPreview from 'src/pages/application-preview/';
import ApplicationStatus from 'src/pages/application-status/';
import Applications from 'src/pages/fs-foundry-applications/';
import LiveEdit from 'src/pages/submissions/live-edit';
import NewFoundry from 'src/pages/profile/foundry-profile/new-foundry';
import PostContract from 'src/pages/contract/post-contract';
import PrintContract from 'src/pages/contract/print-contract';
import SubmissionsCorrect from 'src/pages/submissions/correct';
import SubmissionsDetails from 'src/pages/submissions/details';
import SubmissionsSupportEdit from 'src/pages/submissions/support-edit';
import SubmissionsSupportReview from 'src/pages/submissions/support-review';
import BulkImport from 'src/pages/bulk-import';
import BundleSubmissionDraft from 'src/pages/bundle-submission/pages/BundleSubmissionDraft.vue';
import Dashboard from 'src/pages/dashboard';

import { defaultRouteCallback, loginHandlerCallback, inventoryHubCallback, dropshipCallback, quarterlyEarningsUploadCallback } from './callbacks';

const Impersonate = () => import('src/pages/impersonate');
const InventoryIngestionHub = () => import('src/pages/inventory-ingestion-hub/index.vue');
const UserPermissions = () => import('src/pages/profile/user-permissions/');
const UserProfile = () => import('src/pages/profile/user-profile/');
const Success = () => import('src/pages/success/');
const SignUp = () => import('src/pages/sign-up/');
const Submissions = () => import('src/pages/submissions/');
const Promos = () => import('src/pages/promotions/promos/');
const NewPromo = () => import('src/pages/promotions/new-promo/');
const EditPromo = () => import('src/pages/promotions/edit-promo/');
const SalesReport = () => import('src/pages/sales-report/');
const QuarterlyStatements = () => import('src/pages/quarterly-statements/');
const Settings = () => import('src/pages/settings/');
const PageExpired = () => import('src/pages/expired/');
const Page500 = () => import('src/pages/error-pages/500');
const Page503 = () => import('src/pages/error-pages/503');
const Page403 = () => import('src/pages/error-pages/403');
const Page400 = () => import('src/pages/error-pages/400');
const Page404 = () => import('src/pages/error-pages/404');
const Page412 = () => import('src/pages/error-pages/412');
const Page424 = () => import('src/pages/error-pages/424');
const Contract = () => import('src/pages/contract/');
const FoundryProfile = () => import('src/pages/profile/foundry-profile');
const Home = () => import('src/pages/home/');
const Login = () => import('src/pages/login/');
const Logout = () => import('src/pages/logout/');
const GetStarted = () => import('src/pages/getting-started/');
const BundleSuccess = () => import('src/pages/bundle-submission/pages/success/index.vue');
const Styleguide = () => import('src/pages/styleguide/');
const ViewPromo = () => import('src/pages/promotions/view-promo/');
const PaymentAccounts = () => import('src/pages/payments/payment-accounts');
const PaymentDashboard = () => import('src/pages/payments/payment-dashboard');
const PaymentDataManager = () => import('src/pages/payments/payment-data-manager');
const BundleDashboard = () => import('src/pages/bundle-submission/');
const InventoryIngestionCreate = () => import('src/pages/inventory-ingestion-hub/pages/inventory-ingestion-create');
const NonUfda2 = () => import('src/pages/non-ufda2/');
const MfpNumbers = () => import('src/pages/mfp-numbers/index.vue');
const Dropship = () => import('src/pages/dropship/index.vue');
const UploadFlipFonts = () => import('src/pages/dropship/pages/upload-flip-fonts/index.vue');
const QuarterlyEarningsUpload = () => import('src/pages/quarterly-statements/upload/index.vue');
const VerifyEmail = () => import('src/pages/verify-email/index.vue');
const TerminatedContract = () => import('src/pages/terminated-contract/index.vue');
const ReactivateFontFamilies = () => import('src/pages/reactivate-font-families/index.vue');

export const routes = [
  {
    path: '/login_page',
    component: Login,
    name: 'login_page',
    beforeEnter: loginHandlerCallback
  },
  {
    path: AppRoutesUrl.ERROR_404,
    component: Page404,
    name: '404'
  },
  {
    path: AppRoutesUrl.LOGIN,
    alias: '/',
    name: 'login',
    beforeEnter: defaultRouteCallback
  },
  { path: AppRoutesUrl.LOGOUT, component: Logout, name: 'logout' },
  { path: '/bundle/:id', component: BundleSubmissionDraft, name: 'BundleSubmissionDraft' },
  { path: '/bundle-dashboard', component: BundleDashboard, name: 'BundleDashboard' },
  { path: '/expire', component: PageExpired, name: 'expired' },
  { path: '/bundle/success', component: BundleSuccess, name: 'BundleSuccess' },
  { path: '/get-started', component: GetStarted, name: 'get_started' },
  { path: AppRoutesUrl.VERIFY_EMAIL, component: VerifyEmail, name: AppRoutesName.VERIFY_EMAIL },
  { path: '/terminated-contract', component: TerminatedContract, name: AppRoutesName.TERMINATED_CONTRACT },
  { path: '/sign-up', component: SignUp, name: 'sign_up' },
  { path: '/dashboard', component: Dashboard, name: 'dashboard' },
  {
    path: '/home',
    component: window.localStorage.getItem('roles')?.includes('foundrySupport') ? Home : Dashboard,
    name: 'dashboard_home'
  },
  { path: AppRoutesUrl.HOME, component: Home, name: 'home' },
  { path: AppRoutesUrl.USER_PROFILE, component: UserProfile, name: 'user_profile' },
  { path: AppRoutesUrl.USER_PERMISSIONS, component: UserPermissions, name: 'user_permissions' },
  { path: AppRoutesUrl.FOUNDRY_PROFILE, component: FoundryProfile, name: 'foundry_profile' },
  { path: '/styleguide', component: Styleguide, name: 'styleguide' },
  { path: '/settings', component: Settings, name: 'settings' },
  { path: '/submissions/:id', component: Submissions, name: 'submissions_id' },
  { path: AppRoutesUrl.NON_UFDA2, component: NonUfda2, name: AppRoutesName.NON_UFDA2 },
  {
    path: '/submissions/:id/correct',
    component: SubmissionsCorrect,
    name: 'submissions_correct'
  },
  {
    path: '/submissions/:id/details',
    component: SubmissionsDetails,
    name: 'submissions_details'
  },
  {
    path: '/submissions/:id/:format/details',
    component: SubmissionsDetails,
    name: 'released_submissions_details'
  },
  {
    path: '/submissions/:id/:format/live-edit',
    component: LiveEdit,
    name: 'live_submissions_correct'
  },
  {
    path: AppRoutesUrl.EDIT_FOUNDRY,
    component: NewFoundry,
    name: 'edit_foundry'
  },
  {
    path: AppRoutesUrl.AGREEMENTS,
    component: Contract,
    name: 'contract'
  },
  {
    path: '/print-agreement/:id',
    component: PrintContract,
    name: 'print_contract'
  },
  {
    path: '/sign-agreement/:id',
    component: PostContract,
    name: 'post_contract'
  },
  {
    path: AppRoutesUrl.PROMOTION_DASHBOARD,
    component: Promos,
    name: AppRoutesName.PROMOTION_DASHBAORD
  },
  {
    path: AppRoutesUrl.NEW_PROMOTION,
    component: NewPromo,
    name: AppRoutesName.NEW_PROMOTION
  },
  {
    path: AppRoutesUrl.PROMOTION_SUCCESS,
    component: Success,
    name: AppRoutesName.PROMOTION_SUCCESS
  },
  {
    path: '/payment-accounts/success',
    component: Success,
    name: 'success_pay'
  },
  {
    path: '/submission/success',
    component: Success,
    name: 'success_submission'
  },
  {
    path: '/agreements/status',
    component: Success,
    name: 'success_agreement'
  },
  {
    path: '/sign-up/status',
    component: Success,
    name: 'success_signup_status'
  },
  {
    path: '/sign-up/success',
    component: Success,
    name: 'success_signup'
  },
  {
    path: '/foundry-update/success',
    component: Success,
    name: 'success_foundry_update'
  },
  {
    path: AppRoutesUrl.VIEW_PROMOTION,
    component: ViewPromo,
    name: AppRoutesName.VIEW_PROMOTION,
    props: true
  },
  {
    path: AppRoutesUrl.EDIT_PROMOTION,
    component: EditPromo,
    name: AppRoutesName.EDIT_PROMOTION
  },
  {
    path: '/submissions/:id/edit',
    component: SubmissionsSupportEdit,
    name: 'submissions_support_edit'
  },
  {
    path: '/submissions/:id/review',
    component: SubmissionsSupportReview,
    name: 'submissions_support_review'
  },
  {
    path: AppRoutesUrl.ERROR_500,
    component: Page500,
    name: '500'
  },
  {
    path: AppRoutesUrl.ERROR_503,
    component: Page503,
    name: '503'
  },
  {
    path: AppRoutesUrl.ERROR_403,
    component: Page403,
    name: '403'
  },
  {
    path: AppRoutesUrl.ERROR_400,
    component: Page400,
    name: '400'
  },
  {
    path: AppRoutesUrl.ERROR_412,
    component: Page412,
    name: '412'
  },
  {
    path: AppRoutesUrl.REACTIVATE_FONT_FAMILIES,
    component: ReactivateFontFamilies,
    name: AppRoutesName.REACTIVATE_FONT_FAMILIES
  },
  // TODO fix for lastest vue router
  { path: '/:catchAll(.*)', redirect: AppRoutesUrl.ERROR_404 },
  {
    path: '/applications',
    component: Applications,
    name: 'application'
  },
  {
    path: '/impersonate',
    component: Impersonate,
    name: 'impersonate'
  },
  {
    path: '/inventory-hub',
    component: InventoryIngestionHub,
    name: 'InventoryIngestionHub',
    beforeEnter: inventoryHubCallback
  },
  {
    path: '/create-inventory-ingestion/:id',
    component: InventoryIngestionCreate,
    name: 'InventoryIngestionCreate',
    beforeEnter: inventoryHubCallback
  },
  {
    path: '/application-status',
    component: ApplicationStatus,
    name: 'application_status'
  },
  {
    path: '/application-preview/:id',
    component: ApplicationPreview,
    name: 'application_preview'
  },
  {
    path: AppRoutesUrl.PAYMENT_DASHBOARD,
    component: PaymentDashboard,
    name: 'payment_dashboard'
  },
  {
    path: AppRoutesUrl.PAYMENT_ACCOUNTS,
    component: PaymentAccounts,
    name: 'payment_accounts'
  },
  {
    path: AppRoutesUrl.PAYMENT_ACCOUNTS_NEW_MANAGE,
    component: PaymentDataManager,
    name: 'payment_new_data_manager'
  },
  {
    path: AppRoutesUrl.PAYMENT_ACCOUNTS_EDIT_MANAGE,
    component: PaymentDataManager,
    name: 'payment_edit_data_manager'
  },
  {
    path: AppRoutesUrl.EARNINGS_REPORT,
    component: SalesReport,
    name: AppRoutesName.EARNINGS_REPORT_DASHBOARD
  },
  {
    path: AppRoutesUrl.QUARTERLY_STATEMENTS,
    component: QuarterlyStatements,
    name: AppRoutesName.QUARTERLY_STATEMENTS
  },
  {
    path: AppRoutesUrl.BULK_IMPORT,
    component: BulkImport,
    name: AppRoutesName.BULK_IMPORT
  },
  {
    path: '/payment-accounts/error',
    component: Success,
    name: 'payment_account_error'
  },
  {
    path: AppRoutesUrl.ERROR_424,
    component: Page424,
    name: '424'
  },
  {
    path: AppRoutesUrl.MFP_NUMBERS,
    component: MfpNumbers,
    name: AppRoutesName.MFP_NUMBERS
  },
  {
    path: '/dropship',
    component: Dropship,
    name: AppRoutesName.DROPSHIP,
    beforeEnter: dropshipCallback
  },
  {
    path: AppRoutesUrl.UPLOAD_FLIP_FONTS,
    component: UploadFlipFonts,
    name: AppRoutesName.UPLOAD_FLIP_FONTS,
    beforeEnter: dropshipCallback
  },
  {
    path: AppRoutesUrl.QUARTERLY_EARNINGS_UPLOAD,
    component: QuarterlyEarningsUpload,
    name: AppRoutesName.QUARTERLY_EARNINGS_UPLOAD,
    beforeEnter: quarterlyEarningsUploadCallback
  }
];
